const CONTANTS = {
    MaxLength: {
        Remarks:{
            Short:500,
            Medium:1000,
            Long:2000,
            ExtraLarge:4000
        },
        Codes:{
            Short:20,
            Medium:30,
            Long:50,
        },
        Names:{
            Short:50,
            Medium:100,
            Long:150,
        },
        Address:{
            Short:50,
            Medium:250
        },
        MobileNo: 50,
        ZipCode:10,
        FaxNo:50,
        Description:{
            Short:500,
            Medium:1000,
            Long:2000,
            ExtraLarge:4000
        },
    },
    ORDERTYPE: {
        OTHERS: 1007,
        SPARES: 1004,
        STORES: 1005,
        WORKS: 1006,
    },
    DEFAULT_PORT: {
        "value": 6,
        "label": "SINGAPORE"
    },
    LISTING_REMARKS_LENGTH: 10,
    DECIMAL_VALUE: 2,
    DECIMAL_VALUE_THREE: 3,
    LOCAL_VALUE: 7,
    DISC_VALUE: 4,
    DELIVERYORDER_REPORTS: "/reports/do/",
    REQUISITION_REPORTS: "/reports/pr/",
    INQUIRYQUOTE_REPORTS: "/reports/sq/",
    MLQ_REPORTS: "/reports/mlq/",
    MODULEROUTEKEY_WOR: "/#/wor/view/",
    MODULEROUTEKEY_REQUISITION: "/#/pr/view/",
    APPROVED_STATUS: 4,
    CANCEL_STATUS: 4,
    CANCEL_STATUS_ID: 10,
    QUOTE_MAX_ALLOWED_SUPPLIERS: 3,
    DOCUMENT_UPLOAD_SIZE: 5120,
    DEFAULT_WOR_ORDERTYPEID: 1006,
    FORWARD_TO_USER_GROUP: 5142012120001,
    FORWARD_TO_EMPLOYEE: 9999332017070018,
    QOTATION_VALIDITY_DATE: 7,
    QOTATION_VERSION: 1,
    PURCHASE_REQ_VALIDITY_DATE: 7,
    PURCHASE_MODULE_ID: 31,
    WORK_MODULE_ID: 32,
    PR_RFQ_STATUS: 2,
    DEFAULT_GST_ID: 3,
    FORWARD_BY_USER_GROUP: 3,
    CATEGORYID: 0,
    UAT_ENVIRONMENT: "Fratelli",
    //New Quotation List - Field Validation
    NEWQUOTATION_QUOTECOMPARE: 999,
    NEWQUOTATION_SUPPLIERQUOTATION: 888,
    APPROVAL_STATUS_APPROVE: 2,
    APPROVAL_STATUS_FORWARD: 4,
    APPROVAL_STATUS_REJECT: 3,
    POSTED: 1,
    VERIFIED: 1,
    APPROVED: 1,
    ISCANCEL: 1,
    REJECTED: 1,
    SUBBMITTED: 1,
    CN_APPROVED: 2,
    MODULEID: {
        MASTER: 1,
        ADMIN: 5,
        LOOKNFEEL: 19,
        PMSPURCHASE: 31,
        PMSWORKORDERS: 32,
        Dashboard: 97,
        QUOTECOMPARISION: 98,
        APPROVALCENTER: 99,
    },
    IMPORTDUPLICATECHECKING:{
        ItemDuplicateMessage: "ITEMCODE OR DESCRIPTION IS DUPLICATED",
    },
    TRANSACTIONID: {
        MASTERS: {
            MASTER: 0,
            VESSEL: 2,
            CONTRACTCATEGORY: 4,
            EMPLOYEE: 6,
            GST: 8,
            IMPACATEGORY: 9,
            IMPACODE: 10,
            MAINCODE: 11,
            PORT: 13,
            UOM: 15,
            VENDOR: 16,
            VESSELDEPARTMENT: 17,
            EMPLOYEECATEGORY: 21,
            CREDITTERM: 23,
            EQUIPMENT: 7,
            MODEL: 22,
            SPAREPARTS: 14,
            ORDERTYPE: 12,
            VENDORPIC: 1,
            CURRENCY: 5,
            REASON_FOR_REWARD: 27,
            EQUIPMENT_CATEGORY:28
        },
        ADMIN: {
            ADMIN: 0,
            USERMODULE: 101,
            ACCESSRIGHTS: 102,
        },
        LOOKNFEEL: {
            LOOKNFEEL: 0,
            CLASSIC: 1,
            DARK: 2,
            BLUE: 3,
            GOLD: 4,
        },
        PMSPURCHASE: {
            PMSPURCHASE: 0,
            PURCHASEREQUISITION: 1,
            INQUIRYQUOTE: 3,
            PURCHASEORDER: 4,
            DELIVERYORDER: 5,
            MASTERPRICELIST: 8,
            MASTERLISTQUOTATION: 9,
        },
        PMSWORKORDERS: {
            PMSWORKORDERS: 0,
            WORKORDERREQUISITION: 1,
            WORKORDERINQUIRYQUOTE: 3,
            WORKORDER: 4,
            WORKORDERDELIVERYORDER: 5,
        },
        DASHBOARD: {
            Dashboard: 97,
        },
        QUOTECOMPARISION: {
            QUOTECOMPARISION: 98,
        },
        APPROVALCENTER: {
            APPROVALCENTER: 99,
        },
        RFQ:2
    },
    RoleId: {
        BACKOFFICE: 1,
        VESSEL: 2,
        VENDOR: 3,
    },
    AgGridDataTable: {
        HEIGHT: "85vh",
        WIDTH: "100%",
        GridOptions: {
            tooltipShowDelay: 0,
            rowHeight: 40,
        }
    },
    SUBROLEID: {
        ALL_VESSELS: "203",
    },
    STATUSDESCRIPTION: {
        APPROVED_BC: "APPROVED(BC)",
        FORWARDED: "FORWARDED",
        APPROVED: "APPROVED",
        SUBMITTED: "SUBMITTED",
        ORDER_CONFIRMED: "ORDER CONFIRMED"
    },
    PO_RESTRICTIONS: {
        SQ:"PO is not available either it is modified or removed.",
        PO:"Quotation is not available either it is modified or removed."
    },
    STATUSID:{
        REQUISITION: 1,
        ENQUIRY: 2,
        QUOTATIONS: 3,
        PURCHASE_ORDERS: 4,
        DELIVERY_ORDER: 5,
        DELIVERY_ORDER_PO: 6,
    }
};


export default CONTANTS;
